import DropDown from '../../../../menus/drop-down-react/drop-down';
import {IDropDownOption} from "../../interfaces/interfaces";
import { ArtistsSortEnum } from './artists-sort-enum';
import {useEffect, useState} from "react";
import {useAppDispatch, useAppSelector, rootActions} from "../../data/store";


/**
 * Sort dropdown widget.
 */
export const ArtistsSortDropDown = (props:any) => {
    const dispatch = useAppDispatch();
    const width = props.width;
    const category = useAppSelector(store => store.category);
    const currentLocation = window.location.pathname;
    const [value, setValue] = useState(category.key);

    useEffect( () => {
        if (currentLocation !== '/artists' && currentLocation && currentLocation !== '') {
            let pageLocation = currentLocation.split('/')[2];
            let value;
            switch (pageLocation) {
                case 'post-production-engineers': {
                    value = {
                        key: ArtistsSortEnum.PostProductionEngineers,
                        value: ArtistsSortEnum.PostProductionEngineers,
                        text: 'Post Production Engineers',
                    }
                    break;
                }
                case 'djs-producers': {
                    value = {
                        key: ArtistsSortEnum.DjsOrProducers,
                        value: ArtistsSortEnum.DjsOrProducers,
                        text: 'DJs / Producers',
                    };
                    break;
                }
                case 'live-sound': {
                    value = {
                        key: ArtistsSortEnum.LiveSoundEngineers,
                        value: ArtistsSortEnum.LiveSoundEngineers,
                        text: 'Live Sound Engineers',
                    };
                    break;
                }
                case 'musicians': {
                    value = {
                        key: ArtistsSortEnum.Musicians,
                        value: ArtistsSortEnum.Musicians,
                        text: 'Musicians',
                    };
                    break;
                }
                case 'producers-and-engineers': {
                    value = {
                        key: ArtistsSortEnum.ProducersAndEngineers,
                        value: ArtistsSortEnum.ProducersAndEngineers,
                        text: 'Producers & Engineers',
                    };
                    break;
                }
                default:
                    value = {
                        key:0,
                        value:0,
                        text: 'All Artists'
                    }
            }
            setValue(value.key);
        }
    },[currentLocation])

    const options = [
        {
            key: ArtistsSortEnum.PostProductionEngineers,
            value: ArtistsSortEnum.PostProductionEngineers,
            text: 'Post Production Engineers',
        },
        {
            key: ArtistsSortEnum.ProducersAndEngineers,
            value: ArtistsSortEnum.ProducersAndEngineers,
            text: 'Producers & Engineers',
        },
        {
            key: ArtistsSortEnum.Musicians,
            value: ArtistsSortEnum.Musicians,
            text: 'Musicians',
        },
        {
            key: ArtistsSortEnum.DjsOrProducers,
            value: ArtistsSortEnum.DjsOrProducers,
            text: 'DJs / Producers',
        },
        {
            key: ArtistsSortEnum.LiveSoundEngineers,
            value: ArtistsSortEnum.LiveSoundEngineers,
            text: 'Live Sound Engineers',
        },
        {
            key: ArtistsSortEnum.AllArtists,
            value: ArtistsSortEnum.AllArtists,
            text: 'All Artists',
        },
    ];


    /**
     * apply the sorting
     */
    const applySort = (selection: any) => {
        let url = '';
        switch (selection.key){
            case ArtistsSortEnum.AllArtists: {
                if (window.location.pathname !== '/artists'){
                    url = '/artists';
                }
                break;
            }
            case ArtistsSortEnum.PostProductionEngineers: {
                if (window.location.pathname.indexOf('post-production-engineers') === -1)
                   url='/artists/post-production-engineers';
                break;
            }
            case ArtistsSortEnum.DjsOrProducers: {
                if (window.location.pathname.indexOf('djs-producers') === -1)
                    url='/artists/djs-producers';
                break;
            }
            case ArtistsSortEnum.LiveSoundEngineers: {
                if (window.location.pathname.indexOf('live-sound') === -1)
                    url='/artists/live-sound';
                break;
            }
            case ArtistsSortEnum.Musicians: {
                if (window.location.pathname.indexOf('musicians') === -1)
                    url ='/artists/musicians';
                break;
            }
            case ArtistsSortEnum.ProducersAndEngineers: {
                if (window.location.pathname.indexOf('producers-and-engineers') === -1)
                    url ='/artists/producers-and-engineers';
                break;
            }
            default: {
                url='/artists';
                break;
            }
        }
        setValue(selection.key);
        dispatch(
            rootActions.main({
                category:selection,
        }));
        window.location.href=url;
    };

    return (
        <DropDown
            width={width < 500 ? "190px" : "200px"}
            selectedValue={ value }
            panelClasses="flex items-center border md:border-0 rounded border-gray-500 px-4 py-1 h-10 md:h-auto justify-center md:justify-start"
            title="Choose Category"
            onSelect={(option: IDropDownOption) => {
                applySort(option);
            }}
            options={ options } />
    )
};